module.exports = ".blank_row\n{\n    height: 10px !important; /* overwrites any other rules */\n    background-color: #2e2e46;\n}\n\n.clickable_icon\n{\n  padding: 0px 0px !important;\n  margin: 0px 0px !important;\n  color: #ee7605 !important;\n  background-color: #2e2e46 !important;\n}\n\ntable td, table th\n{\n  padding: 0px 5px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/achelos-iot/operation-info-view/operation-info-view.component.css
// module id = ./src/app/achelos-iot/operation-info-view/operation-info-view.component.css
// module chunks = main